<template>
    <div id="event-listing-internal-wrapper">
        <div class="container wysiwig-wrapper store-list">
            <section class="padded">
                <div class="store-links">
                    <router-link :to="{ name: 'eventListing', query: { }}">
                        <h4>All</h4>
                        <span class="active-indicator"></span>
                    </router-link>
                    <router-link :to="{ name: 'eventListing', query: { store: 'Portland' }}">
                        <h4>Portland</h4>
                        <span class="active-indicator"></span>
                    </router-link>
                    <router-link :to="{ name: 'eventListing', query: { store: 'New York' }}">
                        <h4>New York</h4>
                        <span class="active-indicator"></span>
                    </router-link>
                    <router-link :to="{ name: 'eventListing', query: { store: 'Other' }}">
                        <h4>Other</h4>
                        <span class="active-indicator"></span>
                    </router-link>
                </div>
            </section>
        </div>
        <div class="offwhite-bg">
            <div class="container wysiwig-wrapper">
                <section class="padded">
                    <event-list-item v-for="(event, index) in displayedEvents" v-bind:key="event.id" v-bind:event="event"></event-list-item>
                </section>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../scss/_variables";

    .offwhite-bg {
        background: $c-section-bg;
        padding-bottom: 60px;
    }

    .container.store-list {
        padding-top: 0px;
    }

    .store-links {
        margin-bottom: 50px;
        margin-top: 50px;
        display: flex;
        justify-content: center;

        @media(max-width: 767px) {
            flex-direction: column;
            align-items: flex-start;
        }

        a {
            margin-right: 30px;
            position: relative;
            @media(max-width: 767px) {
                margin-right: 0px;
                margin-bottom: 30px;
            }

            &.router-link-exact-active {
                .active-indicator {
                    display: block;
                }
            }

            .active-indicator {
                display: none;
                width: 100%;
                height: 1px;
                background: #000;
                position: absolute;
                bottom: -8px;
                left: 0;
            }
        }


    }
</style>

<script>
    export default {
        data() {
            return {
                events: [],
                displayedEvents: [],
                activeFilter: ""
            }
        },
        created: function () {
            $('#events-featured-image-parent').show();
            this.events = this.$parent.events;  // not recommended to use this.$parent, but we're never really changing state so it's ok
            this.displayEvents();
        },
        watch: {
            '$route'(to, from) {
                if (to.name === 'eventListing') {
                    this.$nextTick(() => {
                        this.displayEvents();
                    });
                }
            }
        },
        methods: {
            displayEvents: function () {
                const keys = Object.keys(this.getUrlParams());
                if (keys.length !== 0) {
                    const filter = this.getUrlParam('store');
                    // Query present. Filter events.
                    this.displayedEvents = this.filterEvents(filter);
                } else {
                    // No query. Show all events.
                    this.displayedEvents = this.filterEvents(null);
                }
            },
            getUrlParams: function () {
                var result = {};

                // TODO consider implementing URLSearchParams if IE 11 is not supported https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/get#Example
                var params = (window.location.href.split('?')[1] || '').split('&');
                for (var param in params) {
                    if (params.hasOwnProperty(param)) {
                        var paramParts = params[param].split('=');
                        result[paramParts[0]] = decodeURIComponent(paramParts[1] || "");
                    }
                }
                return result;
            },
            getUrlParam: function (param) {
                const parameters = this.getUrlParams();
                if (Object.keys(parameters).includes(param)) {
                    return parameters[param];
                } else {
                    return null;
                }
            },
            filterEvents: function (filter) {
                if (filter !== null && typeof filter !== 'undefined') {
                    this.activeFilter = filter;
                    return this.events.filter((item) => item.eventStoreLocation === filter);
                } else {
                    this.activeFilter = "";
                    return this.events;
                }
            }
        }
    }
</script>
